module.exports = __webpack_public_path__ + "sand.1f0eef6ef44734e4b0b0.png";


//////////////////
// WEBPACK FOOTER
// D:/ptrans/front-end-customer/src/assets/images/themes/footer/style01/sand.png
// module id = ../../../../../src/assets/images/themes/footer/style01/sand.png
// module chunks = 2